import { useAtomValue } from 'jotai';
import { simProductsUrlParamsAtom } from 'src/atoms/filters/sim-products';
import { Routes } from 'src/Routes.constants';

export const useSimProductUrlFromFilters = () => {
  const urlParams = useAtomValue(simProductsUrlParamsAtom);
  return `${Routes.productsSim}?${urlParams}`;
};
